import React from 'react';

const SliderArrow = ({ onClick, type, slideIndex, length }) => {
  const isDisabled = onClick ? '' : 'disabled';
  return (
    <div className={`control ${type}`}>
      <div
        className={`circle ${isDisabled}`}
        onClick={() => {
          if (type === 'left') onClick((slideIndex + length - 1) % length, slideIndex);
          if (type === 'right') onClick((slideIndex + length + 1) % length, slideIndex);
        }}
      >
        <i className={`icon icon-hg-chev-${type}`} />
      </div>
    </div>
  );
};

export default SliderArrow;



// WEBPACK FOOTER //
// ./src/screens/Places/SliderArrow.jsx